import { Text } from '@/lib/v2/components';

interface EmptyTableWithoutDataProps {
  onClickAction?: () => void;
  description: string;
  descriptionAlt: string;
  action: string;
}

const EmptyTableWithoutData = ({
  onClickAction,
  description,
  descriptionAlt,
  action,
}: EmptyTableWithoutDataProps) => {
  return (
    <div className=" max-w-[682px] ">
      <Text className="text-center !text-14 text-emblue-text" fontWeight="normal">
        {description}
      </Text>
      <Text className="text-center !text-14 text-emblue-text" fontWeight="normal">
        {descriptionAlt}
        <button
          className="cursor-pointer !text-14 font-medium text-emblue-primary"
          data-testid="nps-screen-empty-table-create-link"
          role="link"
          onClick={onClickAction}
        >
          {action}
        </button>
      </Text>
    </div>
  );
};

export default EmptyTableWithoutData;
